export default "__VITE_ASSET__Biz_vWH8__"